import M from './JMultiSelectTag.vue'

const JMultiSelectTag = {
  install: function (Vue) {
    Vue.component('JMultiSelectTag', M)
  }
}
export default JMultiSelectTag



// WEBPACK FOOTER //
// ./src/components/dict/multIndex.js